<div class="main-content">
  @if (this.invoiceItems) {
    <div class="invoice-items-section">
      <div class="section-header">
        <h2 class="section-title">Invoice Items (Table Invoice List of Items)</h2>
      </div>
      <div class="terms-conditions">
        <strong>Terms and Conditions:</strong> The document is pursuant to {{this.invoiceData?.brandName}} terms and conditions of sale in effect at the time of this document.
      </div>
      <!-- INVOICE ITEMS TABLE -->
      <table class="invoice-table">
        <thead>
          <tr>
            <th>{{ 'knbrInvoiceDetails.label.materialNum' | cxTranslate }}</th>
            <th>{{ 'knbrInvoiceDetails.label.description' | cxTranslate }}</th>
            <th>{{ 'knbrInvoiceDetails.label.quantity' | cxTranslate }}</th>
            <th>{{ 'knbrInvoiceDetails.label.untPrice' | cxTranslate }}</th>
            <th>{{ 'knbrInvoiceDetails.label.amount' | cxTranslate }}</th>
            <th>{{ 'knbrInvoiceDetails.label.action' | cxTranslate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (invoice of invoiceItems; track invoice) {
            <tr>
              <td>{{ invoice.matNo }}</td>
              <td>{{ invoice.customerMaterialNo }}<br>{{ invoice.description }}</td>
              <td>{{ this.separator(invoice.quantity) }} {{ invoice.quantityUOM }}</td>
              <td>{{ this.formatNetPrice(invoice.netPriceValue) }}</td>
              <td>$ 17,432.07</td>
              <td>
                <button class="submit-case-btn" (click)="navigateToCaseCreationMaterialItem(invoiceData.documentNumber, invoice.matPosNo)">
                  Submit Case
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <!-- TOTALS SECTION -->
      <div class="totals-section">
        <div class="totals-grid">
          <div class="instructions">
            <h4>Instructions:</h4>
            <p>Amount of cash discount is computed by taking the delivered material price less freight and then
            multiplying by the discount rate as per your payment terms.</p>
            <br>
              @if (showRemittanceAddress) {
                <p><strong>Make all remittances payable to the order of:</strong><br>
              {{this.address}}</p>
            }
            <br>
              <p><strong>For billing inquiries:</strong><br>
            Phone 800-260-3101</p>
          </div>
          <div class="totals-table">
            <table>
              <tr>
                <td class="label">{{ 'knbrInvoiceDetails.label.materialTotal' | cxTranslate }}</td>
                @if (this.invoiceData?.materialTotal) {
                  <td class="value">{{ this.toFixed(this.invoiceData?.materialTotal) }}</td>
                }
              </tr>
              @if (this.invoiceData?.freight > 0) {
                <tr>
                  <td class="label">{{ 'knbrInvoiceDetails.label.frieghtCharges' | cxTranslate }}</td>
                  <td class="value">{{ this.separator(this.invoiceData?.freight) }}</td>
                </tr>
              }
              <tr class="total-row">
                <td class="label">{{ 'knbrInvoiceDetails.label.total' | cxTranslate }}</td>
                @if (this.invoiceData?.summaryTotal !== 'null') {
                  <td class="value">{{ this.separator(this.invoiceData?.summaryTotal) }}</td>
                }
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- BACK TO INVOICE LIST -->
    <div class="back-to-invoices">
      <a href="#" class="back-btn" (click)="goBack()">
        {{ 'knbrInvoiceDetails.label.backTo' | cxTranslate }}
      </a>
    </div>
  }
</div>